import { getIsAccountEditingEnabled, getIsLoggedIn } from '@app/ducks';
import { useModalVisibility } from '@app/utils/hooks';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { Notification } from '../Notification';
import { NotificationAction } from '../Notification/NotificationAction';

export const DefaultShippingAddressMissingNotification = () => {
  const { t } = useTranslation(['shipping', 'common']);
  const { showModal } = useModalVisibility('AddShippingCountryModal');
  const isUserLoggedIn = useSelector(getIsLoggedIn);
  const isAccountEditingEnabled = useSelector(getIsAccountEditingEnabled);

  const canAddCountryOrState = isAccountEditingEnabled && isUserLoggedIn;

  const message =
    canAddCountryOrState ?
      t('shipping:shipping_country_state_missing')
    : `${t('shipping:shipping_country_state_missing')} ${t('common:contact_the_seller')}`;

  return (
    <Notification message={message} type="warning">
      {canAddCountryOrState && <NotificationAction onClick={showModal}>{t('shipping:add_country_or_state')}</NotificationAction>}
    </Notification>
  );
};
